import React from 'react';
import { FormikValues } from 'formik';
import { FormItem, SingleFormItemProps } from '../FormItem';
import { SelectInputProps, SelectInput } from './SelectInput';

interface Props<T extends FormikValues> extends SelectInputProps<T> {
  itemProps?: SingleFormItemProps<T>;
  label?: React.ReactNode;
}

/**
 * Form Item per input testuale.
 */
export function SelectInputItem<T extends FormikValues>(props: Props<T>) {
  const { name, label, itemProps, ...otherProps } = props;

  return (
    <FormItem {...itemProps} name={name} label={label}>
      <SelectInput {...otherProps} name={name} />
    </FormItem>
  );
}
